import React from 'react';

export const IconButton = ({
  src, onClick, buttonStyle, imgStyle, alt = '',
}) => (
  <button
    type="button"
    style={{ all: 'unset', cursor: 'pointer', ...buttonStyle }}
    onClick={onClick}
  >
    <img
      src={src}
      alt={alt}
      style={{
        width: 10,
        ...imgStyle,
      }}
    />
  </button>
);
